<div class="pricing-backdrop">
  <div class="pricing-modal">

	 <button class="close-btn" aria-label="Close" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>

    <div class="top-icon">
  <i class="bi bi-lock"></i>
    </div>

    <h2 class="title text-center">Enrollment Locked</h2>
    <p class="text-center">Upgrade your plan to enroll for this course.</p>

    <button class="btn-add w-100" (click)="goToUpgradePage()">Upgrade Now</button>
  </div>
</div>